import '../App.css';
import * as Forms from '../slices/formsSlice';
import NavBar from './navbar';
import NavMenu from './navmenu';
import QuotePurchase from './quotepurchase';
import QuoteRemortgage from './quoteremortgage';
import QuoteSale from './quotesale';
import { useAppDispatch, useAppSelector } from '../slices/index';
import * as Quotes from '../slices/quotesSlice';
import { useEffect, useState } from 'react';
import { AnyAction } from '@reduxjs/toolkit';
import leading_the_way from '../assets/Leading_The_Way_Conveyancing.svg';
import icon_quote from '../assets/Quote_White.svg';
import { useNavigate } from 'react-router-dom';

const Quote = () => {
	const quotes = useAppSelector(state => state.quotes);
	const navigate = useNavigate();
	const dispatch = useAppDispatch();
	const qfid = "QF" + quotes.quote.quoteid;
	const ifid = "IF" + quotes.quote.quoteid;
	const [quoteType, setQuoteType] = useState('');

	const doOnChange = (e: React.ChangeEvent<HTMLInputElement> | React.ChangeEvent<HTMLSelectElement>) => {
		setQuoteType(e.target.value);
	}

	const doOnClick = () => {
		const setquotetype = () => new Promise((resolve) => resolve(dispatch(Quotes.setQuoteType(quoteType))));
		setquotetype().then(() => {
			dispatch((Forms.createFormWithId("QF")));
			dispatch((Forms.createFormWithId("IF")));
			dispatch(Quotes.setOffset('0%'));
		});
	}

	const newQuote = () => {
		const removequoteform = () => new Promise((resolve) => resolve(dispatch((Forms.removeFormWithId("QF")) as unknown as AnyAction)));
		const removeinstructionform = () => new Promise((resolve) => resolve(dispatch((Forms.removeFormWithId("IF")) as unknown as AnyAction)));
		const selquote = () => new Promise((resolve) => resolve(dispatch((Quotes.selectQuote("")) as unknown as AnyAction)));
		removequoteform().then(() => removeinstructionform()).then(() => selquote()).then(() => navigate('/quote'));
	}

	useEffect(() => {
		const setquoteform = () => new Promise((resolve) => resolve(dispatch((Forms.setFormValuesWithJSON({ id: qfid, json: quotes.quote.quoteformdata })) as unknown as AnyAction)));
		const setinstructionform = () => new Promise((resolve) => resolve(dispatch((Forms.setFormValuesWithJSON({ id: ifid, json: quotes.quote.instructionformdata })) as unknown as AnyAction)));
		setquoteform().then(() => {
			setinstructionform();
		})
	}, []);

	return (
		<div className="Home">
			<div style={{ position: 'absolute', top: 96, left: 0, right: 0, bottom: 80 }}>
				<div className='OrangeBand'>
					<div style={{ marginLeft: 'calc(10% + 144px)', marginRight: '10%', width: 'calc(80% - 144px)', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
						<div style={{ display: 'flex', alignItems: 'center' }}>
							<img style={{ width: 96, height: 96, marginRight: 8 }} src={icon_quote} alt='Quote-Icon' />
							<div style={{ marginLeft: 24 }}>
								<div style={{ fontFamily: 'OpenSans-Bold', fontSize: 36, marginBottom: 12, whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>{(quotes.quote.quoteid === '' ? 'Get a Quote' : 'View Quote')}</div>
							</div>
						</div>
						<div>
							<div className='buttonPurple' style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', overflow: 'hidden', padding: 8, fontSize: 18, border: '4px solid white', borderRadius: 16 }} onClick={() => navigate('/loadquotes')}>
								<div style={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>Your Quote List</div>
							</div>
							{quotes.quote.type !== '' &&
								<div className='buttonGreen' style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', overflow: 'hidden', padding: 8, fontSize: 18, border: '4px solid white' }} onClick={() => newQuote()}>
									<div style={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>Get a Quote</div>
								</div>
							}
						</div>
					</div>
				</div>
				{quotes.quote.type === "Purchase" &&
					<QuotePurchase />
				}
				{quotes.quote.type === "Remortgage" &&
					<QuoteRemortgage />
				}
				{quotes.quote.type === "Sale" &&
					<QuoteSale />
				}
				{quotes.quote.type === "" &&
					<div className='GetQuote'>
						<div style={{ maxWidth: 960, padding: 16, margin: 'auto', color: 'black' }}>
							<div style={{ display: 'flex', alignItems: 'center' }}>
								<div className='flexGrow2'>
									<select style={{cursor: 'pointer'}} value={quoteType} onChange={(e) => doOnChange(e)}>
										<option value="">Please Select...</option>
										<option value="Purchase">Purchase</option>
										<option value="Remortgage">Remortgage</option>
										<option value="Sale">Sale</option>
									</select>
								</div>
								<div className='flexGrow1'>
									<div className='buttonGreen' style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', overflow: 'hidden', padding: 8, fontSize: 16, border: '4px solid white', borderRadius: 24 }} onClick={() => doOnClick()}>
										<div style={{ whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>Get a Quote</div>
									</div>
								</div>
							</div>
							<div style={{ color: 'black', fontFamily: 'OpenSans-Bold', fontSize: 16, marginTop: 12 }}>Select from the options above to obtain a quote, or alternatively you can speak to our dedicated New Quotes Team who are on hand 6 days a week. They can talk you through the quotation and answer any questions you have about the costs quoted.</div>
							<div style={{ color: '#513764', fontFamily: 'OpenSans-Bold', fontSize: 36, marginTop: 16 }}>0330 056 5423 / newquotes@pls-solicitors.co.uk</div>
						</div>
					</div>
				}
			</div>

			<div className='mainFooter'>
				<div style={{ marginLeft: '10%', marginRight: '10%', width: '80%', marginTop: 18 }}>
					<img style={{ height: 28 }} src={leading_the_way} alt='LeadingTheWay-Banner' />
				</div>
			</div>
			<div className='loginFooter'></div>
			<NavMenu />
			<NavBar />
		</div>
	);
}

export default Quote;